/**
 * Axios 请求配置
 * 包含请求拦截器、响应拦截器、错误处理等
 */
import axios from 'axios';
import { Toast } from 'vant';
import cookies from 'cookies-js';

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // API 基础路径
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么

    // 方式1: 优先使用 parent 认证（从 cookies 获取）
    // parentId 可以从 m_parent_Id 或 mbparentid 获取
    const parentId = cookies.get('m_parent_Id') || cookies.get('mbparentid');
    // parentToken 从 m_parent_token 或其他字段获取
    const parentToken = cookies.get('m_parent_token') || cookies.get('parent_token') || cookies.get('parentToken');

    if (parentId && parentToken) {
      // 配置特殊的 Authorization 格式: "parent {id} {token}"
      config.headers.Authorization = `parent ${parentId} ${parentToken}`;
      console.log('🔐 Authorization:', `parent ${parentId} ${parentToken.substring(0, 10)}...`);
    } else {
      // 方式2: 兼容普通的 Bearer token
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // 如果是 FormData 类型，修改 Content-Type
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error('请求错误:', error);
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const res = response.data;

    // 根据实际业务需求调整
    // 假设后端返回格式: { code: 0, data: {}, message: '' }
    if (res.code !== undefined && res.code !== 0) {
      Toast.fail(res.message || '请求失败');

      // 特殊状态码处理
      if (res.code === 401) {
        // token 过期或未登录
        localStorage.removeItem('token');
        // 可以跳转到登录页
        // window.location.href = '/login';
      }

      return Promise.reject(new Error(res.message || '请求失败'));
    }

    return res;
  },
  (error) => {
    // 对响应错误做点什么
    console.error('响应错误:', error);

    let message = '网络错误，请稍后重试';

    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      switch (error.response.status) {
        case 400:
          message = '请求参数错误';
          break;
        case 401:
          message = '未授权，请登录';
          localStorage.removeItem('token');
          // window.location.href = '/login';
          break;
        case 403:
          message = '拒绝访问';
          break;
        case 404:
          message = '请求地址不存在';
          break;
        case 500:
          message = '服务器错误';
          break;
        case 502:
          message = '网关错误';
          break;
        case 503:
          message = '服务不可用';
          break;
        case 504:
          message = '网关超时';
          break;
        default:
          message = error.response.data?.message || `请求失败(${error.response.status})`;
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      message = '网络连接失败，请检查网络';
    }

    Toast.fail(message);
    return Promise.reject(error);
  },
);

export default service;

